
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Calendar, Clock } from "lucide-react";
import { format } from "date-fns";

interface BookingDateCardProps {
  date: string | null;
}

const BookingDateCard = ({ date }: BookingDateCardProps) => {
  const formatDate = (dateString: string | null) => {
    if (!dateString) return null;
    try {
      const dateObj = new Date(dateString);
      return {
        date: format(dateObj, "PPP"),
        time: format(dateObj, "h:mm a")
      };
    } catch (e) {
      return null;
    }
  };

  const formattedDate = formatDate(date);

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-base">
          <Calendar className="h-4 w-4 text-primary" />
          Collection Schedule
          <Badge variant={formattedDate ? "secondary" : "outline"} className="ml-auto text-xs">
            {formattedDate ? "Scheduled" : "Pending"}
          </Badge>
        </CardTitle>
      </CardHeader>
      <CardContent>
        {formattedDate ? (
          <div className="space-y-3">
            <div className="flex items-center gap-2">
              <Calendar className="h-4 w-4 text-muted-foreground" />
              <div>
                <p className="text-sm font-medium">{formattedDate.date}</p>
                <p className="text-xs text-muted-foreground">Collection Date</p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <Clock className="h-4 w-4 text-muted-foreground" />
              <div>
                <p className="text-sm font-medium">{formattedDate.time}</p>
                <p className="text-xs text-muted-foreground">Preferred Time</p>
              </div>
            </div>
          </div>
        ) : (
          <div className="text-center py-4">
            <Calendar className="h-8 w-8 text-muted-foreground mx-auto mb-2" />
            <p className="text-sm text-muted-foreground">Collection date not specified</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default BookingDateCard;
